import React from 'react';
import PropTypes from 'prop-types';
import Select from "./Select";
import Flag, { FLAGS } from '../Flag'
import {AngleDown} from "../../../assets/icons";
import {COLORS} from "../../design/tokens";
import Text from "../Text";

const CountrySelector = ({ showPhonePrefix, ...props}) => {
  let options = [];

  // eslint-disable-next-line no-unused-vars
  for (let flag in FLAGS) {
    const { label, phoneCode} = FLAGS[flag];
    const shouldUsePhoneCode = showPhonePrefix && phoneCode;
    if(shouldUsePhoneCode || !showPhonePrefix) {
      options.push({
        label: () => <Text>{label} <Text color={COLORS.TEXT.GRAY}>{phoneCode}</Text></Text>,
        value: `${label} ${phoneCode}`,
        phoneCode: phoneCode,
        icon: () => <Flag key={flag} country={flag} size="xsmall" />
      });
    }
  }

  const Icon = (
    <AngleDown
      viewBox="6 10 45 15"
      fill={COLORS.TEXT.LIGHT_GRAY}
      width={18}
      height={12}
    />
  );

  return (
    <Select
      showSearch
      defaultValue={`${FLAGS["united-states-of-america"].label} ${FLAGS["united-states-of-america"].phoneCode}`}
      options={options}
      showLabel={false}
      className='country-selector'
      dropdownMatchSelectWidth={false}
      style={{
        width: 64,
        minWidth: 64
      }}
      suffixIcon={Icon}
      {...props}
    />
  )
};

CountrySelector.propTypes = {
  ...Select.propTypes,
  showPhonePrefix: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    icon: PropTypes.element
  }))
};

CountrySelector.defaultProps = {
  showPhonePrefix: true
};


export default CountrySelector;
